import { getIsBarcodeScannerEnabled } from '@app/ducks';
import { useGTM } from '@app/utils/analytics';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ProductFilters } from '../../../../../typings';
import { BarcodeScannerButton } from '../Search/BarcodeScannerButton';
import { Search } from '../Search/Search';

interface Props {
  onShowBarcodeScanner?: VoidFunction;
  value?: string;
  onFilterChange: (newFilters: ProductFilters) => void;
  showBarcodeScanner?: boolean;
}

export const SearchFilter = ({ onShowBarcodeScanner, value, onFilterChange, showBarcodeScanner = false }: Props) => {
  const { t } = useTranslation(['common', 'products']);
  const { trackGTMEvent } = useGTM();
  const isBarcodeScannerEnabled = useSelector(getIsBarcodeScannerEnabled) && showBarcodeScanner;

  const handleSearchValue = (search: string) => {
    onFilterChange({ search });
    trackGTMEvent('search', { search_term: search });
    window.scrollTo({ top: 0 });
  };

  return (
    <div className="w-full rounded-regular bg-white px-5 py-3">
      <div className="pb-3 text-neutral-60 heading-4">{t('common:search')}</div>

      <Search value={value} onChange={handleSearchValue} placeholder={t('products:product_search_placeholder')} isFluid>
        {isBarcodeScannerEnabled && <BarcodeScannerButton onShowBarcodeScanner={onShowBarcodeScanner} />}
      </Search>
    </div>
  );
};
